<template>
  <div>

    <div class="row">
      <b-col cols="9">
        <h4>Últimas actualizaciones de siniestros</h4>
        <UltimasActualizaciones></UltimasActualizaciones>
      </b-col>
      <b-col cols="3">
        <br><br>
        <b-card
          title="¿Nuevo en la plataforma?"
          tag="article"
          style="max-width: 20rem"
          class="mb-2"
        >
          <b-card-text>
            <br />
            <img src="@/assets/img/tutorial.png" class="img-fluid" alt="" />
          </b-card-text>

          <b-button target="_blank" href="https://docs.google.com/presentation/d/1OzG-w4n94Y6JzgOqYOuIKXDsaCrVG9u051lIqCDaK9c/edit?usp=sharing" variant="primary"
            >Ver tutorial</b-button
          >
        </b-card>
      </b-col>
    </div>
  </div>
</template>
<script>
import { PostsList } from "@/components/index";
import { UltimasActualizaciones } from "@/components/index";
export default {
  components: {
    PostsList,
    UltimasActualizaciones,
  },
  data() {
    return {};
  },
};
</script>
<style>
</style>
